export type AuthenticationApi = Omit<typeof globalThis.ikea.mvAgent.authentication, 'isLoggedIn'> & {
  isLoggedIn: (force?: boolean) => ReturnType<typeof globalThis.ikea.mvAgent.authentication.isLoggedIn>;
};

// Keep the existing public object; the menu takes over and legacy only fills a gap.
export function registerAuthentication(implementation: AuthenticationApi, owner: 'legacy' | 'menu'): AuthenticationApi {
  globalThis.ikea ??= {} as typeof globalThis.ikea;
  globalThis.ikea.mvAgent ??= {} as typeof globalThis.ikea.mvAgent;
  const existing = globalThis.ikea.mvAgent.authentication;
  if (existing && owner === 'menu') Object.assign(existing, implementation);
  else globalThis.ikea.mvAgent.authentication ??= implementation;
  return globalThis.ikea.mvAgent.authentication;
}
